// noinspection JSUnusedGlobalSymbols

import moment from 'moment';
export default {
  methods: {
    formatBooleanValue({ value }) {
      if (value === null) {
        return '';
      }
      return value ? 'Ja' : 'Nein';
    },
    formatArray({ value }) {
      if (value.length === 1) return Array.isArray(value[0]) ? value[0].join(', ') : value[0];

      return value
          .map(function(item, index) {
            if (typeof (item) === 'number' && item > -1) return null;
            else if (Array.isArray(item) && !item.length) return null;
            else if (!item) return null;
            else return (Array.isArray(item) ? item.join(', ') : item) +' ['+(index+1)+']';
          })
          .filter(Boolean)
          .join('\n');
    },
    formatInstitutes({ value }) {
      const formatInstitute = function(institute) {
        switch (institute) {
          case 'ifm': return 'IfM';
          case 'mhs': return 'MHS';
          case 'ext': return 'extern';
          default: return 'unbekannt';
        }
      };
      if (value.length === 1 && value[0] !== null) return value[0].map(formatInstitute).filter(Boolean).join(', ');
      return value.map((item, index) =>
          item !== null ? item.map(formatInstitute) +' ['+(index+1)+']' : '').filter(Boolean).join('\n');
    },
    formatDate({ value }) {
      return null !== value ? moment(value).format('DD.MM.YYYY') : '';
    },
    formatDateList({ value }) { // is further formatted in vue
      return value.map((date) => date ? moment(date).format('DD.MM.YYYY') : '');
    },
    formatEndDateList({ value }) {
      return value.map((date) => date ? moment(date).format('DD.MM.YYYY') : 'unbefristet');
    },
    formatCitizenship({ value }) {
      const labels = value.map((elem) => {
        // noinspection JSUnresolvedVariable
        return this.filters.citizenships.options.find((obj) => obj.id === elem).name;
      });
      return labels.length ? labels.join(', ') : '';
    },
    formatMaritalStatus({ value }) {
      switch (value) {
        case 'LD':
          return 'ledig';
        case 'VH':
          return 'verheiratet';
        case 'GT':
          return 'getrennt lebend';
        case 'GS':
          return 'geschieden';
        case 'VW':
          return 'verwitwet';
        case 'LP':
          return 'eingetragene Lebenspartnerschaft';
        case 'LA':
          return 'Lebenspartnerschaft aufgehoben';
        case 'LV':
          return 'Lebenspartner verstorben';
        default:
          return '';
      }
    },
    formatHighestDegree({ value }) {
      switch (value) {
        case 'none':
          return 'kein Hochschulabschluss';
        case 'bachelor':
          return 'Bachelor o. vgl.';
        case 'master':
          return 'Master o. vgl.';
        case 'doctorate':
          return 'Promotion';
        case 'habilitation':
          return 'Habilitation';
      }
    },
    formatMainOccupation({ value }) {
      switch (value) {
        case 'scientific':
          return 'Wissenschaftliche*r Beschäftigte*r (Uni)';
        case 'public-service':
          return 'Öffentlicher Dienst';
        case 'assistant':
          return 'Hilfskraft (Uni)';
        case 'other':
          return 'andere Tätigkeit';
        default:
          return '';
      }
    },
    formatSecondaryEmploymentPermit({ value }) {
      switch (value) {
        case 'yes':
          return 'Ja';
        case 'no':
          return 'Nein';
        case 'N/R':
          return 'Nicht erforderlich';
      }
    },
    formatTaxId({ value }) {
      if (value == null) {
        return '';
      }
      return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
    formatDecimalNumberArray({ value }) {
      if (value.length === 1) {
        const decimalNumber = Number(value[0]);
        if (decimalNumber === 0) return '';
        else {
          return decimalNumber
              .toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2});
        }
      } else {
        return value.map(function(item, index) {
          const decimalNumber = Number(item);
          if (decimalNumber === 0) return '';
          else {
            return decimalNumber
                .toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2}) +
                ' [' + (index + 1) + ']';
          }
        }).filter(Boolean).join('\n');
      }
    },
    formatArrayOfDecimalNumberArrays({ value }) {
      if (value.length === 1) {
        const decimalNumbers = value[0];
        if (!decimalNumbers.length) return '';
        else {
          // noinspection JSCheckFunctionSignatures
          return decimalNumbers
              .map((item) => item.toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2}))
              .join('; ');
        }
      } else {
        const arrays = value.map((array, index) => {
          if (!array.length) return null;
          // noinspection JSCheckFunctionSignatures
          return array
              .map((item) => item.toLocaleString('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2}))
              .join('; ') + ' [' + (index + 1) + ']';
        });

        return arrays.filter(Boolean).join('\n');
      }
    },
  },
};
